import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import * as httpUtil from "@/utils/httpUtil";
const interfaces = [{
  method: "post",
  name: "cancelAppointment",
  url: "/c/pc/appointmentArrival/cancelAppointment",
  desc: "取消预约"
}, {
  method: "post",
  name: "editUserAppointmentArrivalConfig",
  url: "/c/pc/appointmentArrival/editUserAppointmentArrivalConfig",
  desc: "编辑社区预约到店用户预约设置"
}, {
  method: "postExFile",
  name: "exportAppointment",
  url: "/c/pc/appointmentArrival/exportAppointment",
  desc: "导出预约到店服务管理列表"
}, {
  method: "post",
  name: "appointmentArrivalFindById",
  url: "/c/pc/appointmentArrival/findById",
  desc: "查询预约到店详情"
}, {
  method: "post",
  name: "appointmentArrivalGetConfig",
  url: "/c/pc/appointmentArrival/getConfig",
  desc: "查询社区预约到店服务开关配置"
}, {
  method: "post",
  name: "getUserAppointmentArrivalConfig",
  url: "/c/pc/appointmentArrival/getUserAppointmentArrivalConfig",
  desc: "查询社区预约到店用户预约设置"
}, {
  method: "post",
  name: "appointmentArrivalPageList",
  url: "/c/pc/appointmentArrival/pageList",
  desc: "分页查询社区预约到店服务管理列表"
}, {
  method: "post",
  name: "updateInsuranceRightStatus",
  url: "/c/pc/appointmentArrival/updateInsuranceRightStatus",
  desc: "更新惠民保健康权益预约状态(确认预约、核销)"
}, {
  method: "post",
  name: "reappointment",
  url: "/c/pc/appointmentArrival/reappointment",
  desc: "重新预约"
}, {
  method: "post",
  name: "updateAppointment",
  url: "/c/pc/appointmentArrival/updateAppointment",
  desc: "修改预约"
}, {
  method: "post",
  name: "appointmentArrivalUpdateConfig",
  url: "/c/pc/appointmentArrival/updateConfig",
  desc: "编辑社区预约到店服务开关配置",
  config: {
    ignoreError: true
  }
}];
function exportsRender(interfacesArr) {
  const resultExports = {};
  interfacesArr.map(item => {
    resultExports[item.name] = data => {
      return httpUtil[item.method](item.url, data, item.config);
    };
  });
  return resultExports;
}
export default exportsRender(interfaces);